// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3PwC5","right":"Footer_right__1XzEp","buttons":"Footer_buttons__2ndHg"};